import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import RangePicker from 'react-bootstrap-daterangepicker';
import { Typeahead } from 'react-bootstrap-typeahead';

function Header(props) {
  const formatDate = (date) => moment(date).format('ll');

  return (
    <div className="dealer-revisions-header">
      <div className="header-row">
        <div className="datepicker-container">
          <div className="header-label">Date Range</div>
          <RangePicker
            startDate={props.dateRange[0]}
            endDate={props.dateRange[1]}
            onApply={(_, range) => {
              props.setDateRange([range.startDate, range.endDate]);
            }}
          >
            <div className="datepicker">
              <div className="datepicker-icon ">
                <i className="glyphicon glyphicon-calendar" />
              </div>
              {formatDate(props.dateRange[0])} –{' '}
              {formatDate(props.dateRange[1])}
            </div>
          </RangePicker>
        </div>
        <div className="user-filter-container">
          <div className="header-label">User</div>
          <Typeahead
            id="user-filter"
            clearButton
            selectHintOnEnter
            placeholder="Filter by User"
            labelKey="label"
            selected={props.user ? [props.user] : []}
            onChange={(selected) => props.setUser(selected[0])}
            options={props.userOptions}
            data-dd-privacy="mask"
            className="amp-mask"
          />
        </div>
      </div>
      <div className="header-row">
        <div className="type-filter-container">
          <div className="header-label">Type</div>
          <Typeahead
            id="type-filter"
            clearButton
            labelKey="label"
            selectHintOnEnter
            placeholder="Filter by Data Type"
            selected={props.type ? [props.type] : []}
            onChange={(selected) => {
              props.setType(selected[0]);
              props.setField(null);
            }}
            options={props.typeOptions}
          />
        </div>
        <div className="type-filter-container">
          <div className="header-label">Fields</div>
          <Typeahead
            id="field-filter"
            clearButton
            selectHintOnEnter
            disabled={!props.type}
            placeholder="Filter by Field ID"
            selected={props.field ? [props.field] : []}
            onChange={(selected) => props.setField(selected[0])}
            options={props.fieldOptions}
          />
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {
  dateRange: PropTypes.array,
  user: PropTypes.object,
  type: PropTypes.object,
  field: PropTypes.string,
  setUser: PropTypes.func,
  setType: PropTypes.func,
  setField: PropTypes.func,
  setDateRange: PropTypes.func,
  userOptions: PropTypes.array,
  typeOptions: PropTypes.array,
  fieldOptions: PropTypes.array,
};

export default Header;
